import React, { Component } from 'react';
import Parser from 'html-react-parser'

class First extends Component {
  static defaultProps = {

  }

  state = {

  }

  constructor(props) {
    super(props)


  }

  render() {

    const data = this.props?.data || {}
    const history = data?.history_ng

    return (
      <div className='mt-[80px] xl:mt-[100px] w-full'>
        <div className='container'>
          <div className='w-full flex items-center justify-between gap-[20px]'>
            <div className='hidden xl:flex items-center gap-[20px]'>
              <img src={history?.image_1} width={482} height={170} className='h-auto flex-none' />
              <img src={history?.image_2} width={172} height={170} className='h-auto flex-none' />
            </div>
            <div className='leading-none text-start xl:text-end'>
              <div className='text-title text-ptblack uppercase tracking-tight'>{Parser(history?.title || '')}</div>
              <div className='text-ptgray text-base mt-[12px]'>
                {Parser(history?.text || '')}
              </div>
            </div>
          </div>
          <div className='xl:hidden w-full mt-[40px]'>
            <img src={history?.image_m_1} width={355} height={200} className='w-full h-auto flex-none' />
            <img src={history?.image_m_2} width={355} height={160} className='w-full h-auto flex-none mt-[10px]' />
          </div>
        </div>
      </div>
    )
  }
}

export default First;